/**
 * orderType обязателен для /guest/categories, /guest/products и
 * /guest/products/{id} (спека §4.5). Виджет работает в предзаказе: оба
 * живых вызова loadMenu передавали OrderType.PreOrder жёстко, а app-слайс
 * типа заказа не хранит вовсе. Появится второй режим — параметр добавится
 * аддитивно.
 */
export const MENU_ORDER_TYPE = "PRE_ORDER" as const;

/**
 * Размер страницы обхода меню. Потолок схемы — 100.
 *
 * Константой модуля, а не литералом в хуке: на деве в меню три товара, и
 * прогон дочитки живьём возможен только принудительным уменьшением.
 */
export const MENU_PAGE_SIZE = 100;

/**
 * Ключ обхода меню.
 *
 * Живёт здесь, рядом с GUEST_MENU_PATHS, а не в guest-hooks: его читает
 * бутстрап сессии, и тащить туда openapi-react-query ради одной константы
 * незачем — ровно тот же довод, что у списка путей ниже.
 *
 * Ключ полностью отдельный: TanStack сравнивает ЭЛЕМЕНТЫ ключа, и
 * `["get", "/guest/products"]` обход не накрывает — как `"/orders"` не
 * накрывает `"/orders/counts"`. Строка "/guest/products" в GUEST_MENU_PATHS
 * после круга 7 не гасит ничего и оставлена на случай, когда у маршрута
 * появится потребитель через api.useQuery; на `/guest/products/{id}` она
 * при этом НЕ распространяется — тот перечислен своей строкой.
 */
export const GUEST_PRODUCTS_LIST_KEY = ["guest-products", "list"] as const;

/**
 * Пути, которые бутстрап сессии обязан инвалидировать после подъёма.
 *
 * Живут в константах, а не в guest-hooks: иначе bootstrap.ts тащил бы
 * в себя openapi-react-query ради одного списка строк.
 */
export const GUEST_MENU_PATHS = [
  "/guest/points/{id}",
  "/guest/categories",
  "/guest/products",
  "/guest/products/{id}",
  "/guest/product-tags",
  "/guest/product-variant-properties",
  "/guest/option-groups",
  "/guest/options",
  "/guest/images",
] as const;
